"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        plot: {
            width: '100%',
        },
        skeletonContainer: {
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'flex-end',
        },
        tooltipContainer: {
            borderRadius: 20,
            background: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.8),
            padding: '5px 10px',
            position: 'relative',
            '&:after': {
                top: '100%',
                left: '50%',
                border: 'solid transparent',
                content: '""',
                height: 0,
                width: 0,
                position: 'absolute',
                pointerEvents: 'none',
                borderTopColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.8),
                borderWidth: 8,
                marginLeft: -8,
            },
        },
    });
});
